import React, { useEffect, useState, Component } from 'react';
import { LandingPage } from './pages/LandingPage';
import { ReferralPage } from './pages/ReferralPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
import { ThankYouPage } from './pages/ThankYouPage';
import { ThankYouReferralPage } from './pages/ThankYouReferralPage';
import { AiCoursePage } from './pages/AiCoursePage';
import { InstagramAdsPage } from './pages/InstagramAdsPage';
import { SalePage } from './pages/SalePage';
import { SmsPage } from './pages/SmsPage';
import { ThemeProvider } from './contexts/ThemeContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { PricingProvider } from './contexts/PricingContext';
import { SEO } from './components/SEO';
import { captureUTMParams } from './utils/utm';
// Инициализация Meta Pixel (stub), чтобы fbq был доступен до загрузки основного скрипта
if (typeof window !== 'undefined' && !window.fbq) {
  window.fbq = function () {
    window.fbq.callMethod ? window.fbq.callMethod.apply(window.fbq, arguments) : window.fbq.queue.push(arguments);
  };
  window.fbq.queue = [];
  window.fbq.version = '2.0';
  window.fbq.loaded = true;
}
export function App() {
  const [currentPath, setCurrentPath] = useState(window.location.pathname);
  // Основной эффект для UTM и отслеживания Pixel
  useEffect(() => {
    // 1. Фиксируем UTM параметры
    captureUTMParams();
    // 2. Отправляем PageView в Meta Pixel при каждом изменении пути (SPA FIX)
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'PageView');
    }
    // Слушаем нажатия кнопок "Назад/Вперед" в браузере
    const handlePopState = () => {
      setCurrentPath(window.location.pathname);
    };
    // Слушаем программные переходы (если ваше приложение использует их)
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [currentPath]); // Эффект перезапускается при каждом изменении URL
  // Логика роутинга
  let PageComponent = LandingPage;
  let pageName = 'home';
  // Очистка пути от языковых префиксов (en, ru, ua)
  let normalizedPath = currentPath;
  if (currentPath.startsWith('/ru')) {
    normalizedPath = currentPath.substring(3);
  } else if (currentPath.startsWith('/ua')) {
    normalizedPath = currentPath.substring(3);
  } else if (currentPath.startsWith('/uk')) {
    normalizedPath = currentPath.substring(3);
  } else if (currentPath.startsWith('/en')) {
    normalizedPath = currentPath.substring(3);
  }
  if (normalizedPath === '' || normalizedPath === '/') {
    normalizedPath = '/';
    PageComponent = LandingPage;
    pageName = 'home';
  } else if (normalizedPath === '/referral') {
    PageComponent = ReferralPage;
    pageName = 'referral';
  } else if (normalizedPath === '/sale') {
    PageComponent = SalePage;
    pageName = 'sale';
  } else if (normalizedPath === '/sms') {
    PageComponent = SmsPage;
    pageName = 'sms';
  } else if (normalizedPath === '/privacy') {
    PageComponent = PrivacyPage;
    pageName = 'privacy';
  } else if (normalizedPath === '/terms') {
    PageComponent = TermsPage;
    pageName = 'terms';
  } else if (normalizedPath === '/thank_you_page') {
    PageComponent = ThankYouPage;
    pageName = 'thankYou';
  } else if (normalizedPath === '/thank-you-referral') {
    PageComponent = ThankYouReferralPage;
    pageName = 'thankYouReferral';
  } else if (normalizedPath === '/buy-it-business') {
    PageComponent = AiCoursePage;
    pageName = 'aiCourse';
  } else if (normalizedPath === '/instagram_ads') {
    PageComponent = InstagramAdsPage;
    pageName = 'instagramAds';
  }
  return <ThemeProvider data-id="element-0">
      <LanguageProvider data-id="element-1">
        <PricingProvider data-id="element-2">
          <SEO page={pageName} data-id="element-3" />
          <PageComponent data-id="element-4" />
        </PricingProvider>
      </LanguageProvider>
    </ThemeProvider>;
}